import { NavLink } from 'react-router-dom';

/** Dev Tools has one sidebar entry; this moves between its pages. */
const PAGES = [
  { to: '/dev-tools', label: 'Delivery requests', end: true },
  { to: '/dev-tools/jotform', label: 'Jotform relay', end: false },
  { to: '/dev-tools/email', label: 'Email allowlist', end: false },
];

const DevToolsNav = () => (
  <div className='mt-4 flex gap-4 border-b'>
    {PAGES.map((page) => (
      <NavLink
        key={page.to}
        to={page.to}
        end={page.end}
        className={({ isActive }) =>
          `body-01 -mb-px pb-2 ${isActive ? 'border-b-2 border-blue-700 font-semibold text-blue-700' : 'text-gray-600'}`
        }
      >
        {page.label}
      </NavLink>
    ))}
  </div>
);

export default DevToolsNav;
